var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutlerySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 516 516",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M504,429.2l-198.4-176l16-17.6c8,3.2,16,4.8,24,4.8c16,0,32-6.4,44.8-17.6L507.2,106c6.4-6.4,6.4-16,0-22.4 c-6.4-6.4-16-6.4-22.4,0l-89.6,89.6c-1.6,1.6-6.4,3.2-12.8,1.6c-4.8-1.6-9.6-3.2-14.4-6.4L472,66c6.4-6.4,6.4-16,0-22.4 c-6.4-6.4-16-6.4-22.4,0L348.8,144.4c-4.8-8-6.4-14.4-6.4-19.2c0-1.6,0-4.8,1.6-6.4l89.6-89.6c6.4-6.4,6.4-16,0-22.4 c-6.4-6.4-16-6.4-22.4,0L294.4,123.6c-14.4,14.4-20.8,36.8-16,57.6c-1.6,0-1.6-1.6-3.2-1.6C248,155.6,139.2,58,59.2,10 C33.6-6,16,6.8,9.6,13.2C-3.2,26-3.2,45.2,9.6,58l196.8,196.8L12.8,442c-16,16-16,43.2,0,59.2c8,8,19.2,12.8,28.8,12.8 c11.2,0,22.4-4.8,30.4-12.8l185.6-196.8L443.2,490c8,8,19.2,12.8,30.4,12.8c11.2,0,20.8-4.8,30.4-12.8 C520,474,520,446.8,504,429.2z M313.6,147.6c4.8,11.2,11.2,22.4,20.8,32c9.6,9.6,20.8,16,32,20.8c-12.8,11.2-33.6,9.6-48-4.8 C304,181.2,302.4,160.4,313.6,147.6z M283.2,226l9.6-9.6c0,0,1.6,1.6,1.6,3.2l-11.2,12.8V226z M49.6,478.8 c-3.2,3.2-9.6,3.2-14.4,0c-3.2-3.2-3.2-9.6,0-14.4l195.2-188.8l4.8,4.8L49.6,478.8z M480,467.6c-3.2,3.2-9.6,3.2-14.4,0l-224-224 l-208-208c0-1.6,1.6-3.2,9.6,1.6c76.8,44.8,184,144,208,164.8v36.8c0,4.8,1.6,9.6,4.8,11.2l16,14.4l208,187.2 C483.2,456.4,483.2,462.8,480,467.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlerySvgrepoCom);
export default __webpack_public_path__ + "static/media/cutlery-svgrepo-com.4665e80b.svg";
export { ForwardRef as ReactComponent };